import { TranslationKey } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { isAllowedModelType } from '../../../../__legacy__/modules/datasets/helpers/image.helpers';
import { ImportModal } from '../../components/list/ImportModal';

interface IImportModalProps {
  showModal: boolean;

  toggleModal(): void;
  importJobAsync(name: string, description: string, file: File): Promise<boolean>;
  clearImportErrors(): void;
}

interface IState {
  name: string;
  description: string;
  file: File | null;
  errors: {
    showStatus: boolean;
    name?: TranslationKey;
  };
  rejectedFiles: File[];
  acceptedFiles: File[];
}

const DEFAULT_MODAL_STATE = {
  name: '',
  description: '',
  errors: {
    showStatus: false,
    name: undefined,
  },
  file: null,
  rejectedFiles: [],
  acceptedFiles: [],
};

export const ImportModalContainer = observer((props: IImportModalProps): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<IState>({ ...DEFAULT_MODAL_STATE });

  const validateRequiredTextField = (value: string): TranslationKey => {
    return value.length === 0 ? 'field_cant_be_empty' : '';
  };

  const handleChangeTextField =
    (key: string) =>
    (value: string): void => {
      const errors: IState['errors'] = {
        ...data.errors,
        showStatus: true,
      };

      if (key === 'name') {
        errors[key] = validateRequiredTextField(value);
      }

      setData({
        ...data,
        errors,
        [key]: value,
      });
    };

  const handleImageDrop = (images: File[]): void => {
    if (isAllowedModelType(images[0])) {
      setData({
        ...data,
        file: images[0],
        acceptedFiles: [images[0]],
        rejectedFiles: [],
      });
    } else {
      setData({
        ...data,
        file: null,
        rejectedFiles: [images[0]],
        acceptedFiles: [],
      });
    }
  };

  const handleSubmit = async (): Promise<void> => {
    if (!data.file) {
      return;
    }

    setIsLoading(true);
    const result = await props.importJobAsync(data.name, data.description, data.file);

    if (result) {
      toggleModal();
    }

    setIsLoading(false);
  };

  const toggleModal = (): void => {
    if (props.showModal) {
      props.clearImportErrors();
      setData({ ...DEFAULT_MODAL_STATE });
    }

    props.toggleModal();
  };

  const removeSelectedFile = (): void => {
    props.clearImportErrors();
    setData({ ...data, acceptedFiles: [], file: null });
  };

  return (
    <ImportModal
      showModal={props.showModal}
      toggleModal={toggleModal}
      data={data}
      handleChangeTextField={handleChangeTextField}
      handleImageDrop={handleImageDrop}
      removeSelectedFile={removeSelectedFile}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
    />
  );
});
